
import { Component, Vue, Prop } from 'vue-property-decorator'
import { PermissionClient } from '@/api'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
@Component({
  name: 'PermissionEditor'
})
export default class extends BaseEditor {
  public constructor() {
    super()
    this.client = new PermissionClient()
    this.data = { name: '', description: '' }
    this.rules = {
      name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
      description: [{ required: true, message: '描述不能为空', trigger: 'blur' }]
    }
  }

  public async reset() {
    this.data = { name: '', description: '' }
  }

  protected generateData():any {
    return _.pick(this.data, ['name', 'description'])
  }
}
